import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface AppLink {
  id: string;
  url: string;
  title: string;
}

export const appLinksApi = createApi({
  reducerPath: 'appLinksApi',
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers) => {
      headers.set('X-CSRF', '1');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAppLinks: builder.query<AppLink[], void>({
      query: () => `/app-links`,
    }),
  }),
});

export const { useGetAppLinksQuery } = appLinksApi;
